import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository-new';

import { CodesRepository } from '@/domain/repositories/codes/codes.repository.contract';
import { IosInstallCodeDto } from '@/dtos/codes/codes.dto';
import { mapIosInstallCode } from '@/mappers/codes/codes.mapper';
import { IosInstallCode } from '@/models/codes/codes.model';

@Injectable({
  providedIn: 'root'
})
export class CodesRepositoryImpl extends MRepository implements CodesRepository {
  protected override readonly baseUrl = `${ENV.API_URL}`;

  getAppUrl(store: string): Observable<IosInstallCode> {
    let params = new HttpParams();
    params = params.set('store', store);
    return this.get<IosInstallCodeDto>(`/ios-enterprise/code`, { params }).pipe(map(mapIosInstallCode));
  }
}
